<template>
  <div :class="`sm:col-span-12 md:col-span-3 transition-all ease-in-out duration-200 ${needHelpButton.isClicked ? 'mr-2' : '-mr-92'}`">
    <div :class="`pl-4 md:fixed left-0 md:left-auto w-full md:w-1/4 transition-all ease-in-out duration-200 ${needHelpButton.isClicked ? 'opacity-100 translate-x-0 z-50 -mr-4' : 'opacity-0 translate-x-3 -z-1 -mr-92'}`">
      <div :class="`mx-4 shadow-md rounded ${needHelpButton.isClicked ? 'in' : null }`" v-if="needHelpButton.isClicked" style="min-height: 38rem; max-height: 38rem">
        <div class="bg-blue-500 rounded-tl-lg rounded-tr-lg flex justify-between">
          <h3 class="p-4 text-white font-medium text-lg">Request Assistance</h3>
          <button
              @click.prevent.stop="buttonClicked()"
              class="pr-4 text-white"
          >
            <XIcon />
          </button>
        </div>
        <div class="">
          <div class="p-4" v-if="!submitted">
            <p>Please describe how we can assist you in the field below and we will be in contact with you.</p>
            <form class="form  mt-4">
              <div class="grid grid-cols-3 gap-4">
                <div class="col-span-3">
                  <div class="mb-2 text-sm dark:text-darkTextLight font-medium">
                    <label>Full Name</label>
                  </div>
                  <input
                      class="form__input form__input--block"
                      v-model="data.name"
                      type="text"/>
                </div>
                <div class="col-span-3">
                  <div class="mb-2 text-sm dark:text-darkTextLight font-medium">
                    <label>Contact Number</label>
                  </div>
                  <input
                      class="form__input form__input--block"
                      v-model="data.contact"
                      type="text"/>
                </div>
                <div class="col-span-3">
                  <div class="mb-2 text-sm dark:text-darkTextLight font-medium">
                    <label>Subject</label>
                  </div>
                  <input
                      class="form__input form__input--block"
                      v-model="data.subject"
                      type="text"/>
                </div>
                <div class="col-span-3">
                  <div class="mb-2 text-sm dark:text-darkTextLight font-medium">
                    <label>Message</label>
                  </div>
                  <textarea
                      class="w-full h-28 border-solid border-gray-400 border rounded-lg focus:outline-none p-4 text-sm placeholder-gray-700 font-normal"
                      v-model="data.message"
                      placeholder="Write your question about this fee agreement here">
                    </textarea>
                </div>
                <div class="col-span-3 text-right">
                  <button :class="`btn btn--default ${(loading || !isEnabled) ? 'opacity-40 cursor-not-allowed' : ''}`" @click.prevent.stop="submit">{{(loading) ? 'Sending...' : 'Send'}}</button>
                </div>
              </div>
            </form>
          </div>
          <div class="" v-else>
            <div class="bg-white dark:bg-coolGray-800 rounded-lg p-16 overflow-x-auto flex-1 max-w-2xl mx-auto">
              <div class="flex justify-center mt-8">
                <div class="ml-2"><CheckCircleIcon size="3x" class="mt-0.5 mr-1 text-green-400" /></div>
              </div>
              <div class="text-center text-black font-semibold text-xl mt-2">
                Message successfully sent
              </div>
              <div class="text-center">
                <p class="mt-4">We will be in contact with you shortly.</p>
                <p class="mt-12">Send new message?</p>
                <div class="flex justify-center mt-4">
                  <button class="btn btn--default w-24" @click.prevent.stop="newMessageButtonClicked('no')">No</button>
                  <button @click.prevent.stop="newMessageButtonClicked('yes')" class="btn btn--primary w-24 ml-4">Yes</button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import {mapActions, mapGetters} from "vuex";
import { XIcon, CheckCircleIcon } from 'vue-feather-icons'
export default {
  name: 'NeedHelp',
  components: {
    XIcon,
    CheckCircleIcon
  },
  data() {
    return {
      data: {
        subject: null,
        message: null,
        name: null,
        contact: null,
      },
      isEnabled: false,
      showModal: false,
      loading: false,
      hasError: false,
      success: false,
      submitted: false,
      error: {}
    }
  },
  computed: {
    ...mapGetters({
      needHelpButton: 'client/needHelpButton',
      caseManager: 'client/getCaseManager',
      feeAgreement: 'client/feeAgreement'
    })
  },
  watch: {
    data:{
      handler: function(val) {
        if(val.contact && val.message && val.name && val.subject){
          this.isEnabled = true;
        }else{
          this.isEnabled = false;
        }
      },
      deep: true
    }
  },
  methods: {
    ...mapActions({
      setNeedHelpButton: 'client/setNeedHelpButton'
    }),
    clear(){
      this.data = {
        subject: null,
        message: null,
        name: null,
        contact: null,
      }
    },
    newMessageButtonClicked(type){
      this.submitted = false;
      if(type === 'no'){
        this.setNeedHelpButton({isClicked: false});
      }
    },
    buttonClicked() {
      this.setNeedHelpButton({isClicked: false})
    },
    submit() {
      if (this.loading && !this.success) {
        return;
      }

      let _this = this;

      this.loading = true;
      this.hasError = false;
      this.submited = false;

      let project = this.getProject();
      this.data.email_to = project.case_manager.email

      this.$http.post(this.app.version + '/front/request-assistance', this.data)
          .then(response => {
            this.loading = false;

            if (! response.data.success) {
              this.hasError = true;
            } else {
              this.success = true;
            }

            this.submitted = true;
            this.clear();
            setTimeout(() => {
              this.resetForm();
            }, 5000);

          })
          .catch((error) => {
            // internal error
            if (error.response.status != 422) {
              this.hasError = true;
            }
            this.error = error.response.data;
            this.loading = false;
            this.submitted = true;
          })
    },
  }
}
</script>